<template>
  <div data-qa="myprofileaddresslookup-div-vhvpni">
    <ConfirmExit
      v-if="showExitConfirmation"
      v-on:isLeavingRoute="$emit('close')"
      v-on:isNotLeavingRoute="showExitConfirmation = false"
      :title="resource.leaveAddressLookupTitle"
      :text="
        settings.enableManualEntryForAddressLookup
          ? resource.selectAddressOrEnterManually
          : resource.selectAddress
      "
    />
    <v-dialog
      content-class="my-profile-address-lookup-dialog"
      scrollable
      width="400px"
      transition="dialog-bottom-transition"
      persistent
      v-model="showMe"
     data-qa="myprofileaddresslookup-dialog-x1jxud">
      <v-card data-qa="myprofileaddresslookup-card-hf9j5">
        <v-toolbar :color="secondaryColor" class="white--text" data-qa="myprofileaddresslookup-toolbar-ljmqfu">
          <v-toolbar-title data-qa="myprofileaddresslookup-toolbar-title-7pi9bn">{{ $t("personalSettings.addressLookup.addressLookupLabel") }}</v-toolbar-title>
          <v-spacer data-qa="myprofileaddresslookup-spacer-39vdzu"></v-spacer>
          <v-btn icon @click="showSearchText = !showSearchText" data-qa="myprofileaddresslookup-btn-va3x9j">
            <v-icon color="white" data-qa="myprofileaddresslookup-icon-p30y1">mdi-text-search</v-icon>
          </v-btn>
          <v-btn icon @click="showExitConfirmation = true" data-qa="myprofileaddresslookup-btn-wvhcs9">
            <v-icon color="white" data-qa="myprofileaddresslookup-icon-jx8jgp">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-text-field data-qa="myprofileaddresslookup-text-field-7czc7m"
          v-if="showSearchText"
          v-model="filterAddress"
          :label="$t('personalSettings.addressLookup.searchAddressHint')"
          :color="primaryColor"
          minlength="6"
          prepend-inner-icon="mdi-text-search"
          clearable
          outlined
          hide-details
          class="pa-3"
        />
        <v-divider data-qa="myprofileaddresslookup-divider-1tjcla"></v-divider>
        <v-card-text class="pa-0" data-qa="myprofileaddresslookup-card-text-a2hqv8">
          <v-list data-qa="myprofileaddresslookup-list-07lnn">
            <v-list-item
              v-for="(item, i) in filteredAddresses"
              :key="i"
              :color="secondaryColor"
              class="pa-2"
              @click="itemClicked(item)"
             :data-qa="`myprofileaddresslookup-list-item-4t09kv-${i}`">
              <v-list-item-icon class="mr-2 ml-2" :data-qa="`myprofileaddresslookup-list-item-icon-v62wk5-${i}`">
                <v-icon :color="secondaryColor" :data-qa="`myprofileaddresslookup-icon-14mi4-${i}`">
                  mdi-map-marker-outline
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content :data-qa="`myprofileaddresslookup-list-item-content-vhvnp-${i}`">
                <v-list-item-title class="text-wrap text-uppercase" :data-qa="`myprofileaddresslookup-list-item-title-04gm7-${i}`">{{
                  item.formattedAddress
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions data-qa="myprofileaddresslookup-card-actions-ozqfkk">
          <v-checkbox data-qa="myprofileaddresslookup-checkbox-155jek"
            v-if="settings.enableManualEntryForAddressLookup"
            :value="addAddressManually"
            :label="
              this.$t('personalSettings.addressLookup.addAddressManuallyLabel')
            "
            :color="primaryColor"
            class="pa-2"
            @change="$emit('clickAddAddressManually', $event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CommonService from '@/service/commonService.js'

export default {
  props: {
    search: String,
    addressList: Array,
    addAddressManually: Boolean
  },
  components: {
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue')
  },
  data () {
    return {
      addresses: [],
      addressIcon: 'mdi-map-marker-outline',
      filterAddress: '',
      resource: {
        leaveAddressLookupTitle: this.$t(
          'personalSettings.addressLookup.leaveAddressLookupTitle'
        ),
        selectAddress: this.$t('personalSettings.addressLookup.selectAddress'),
        selectAddressOrEnterManually: this.$t(
          'personalSettings.addressLookup.selectAddressOrEnterManually'
        )
      },
      settings: {
        isLoqate:
          this.$appSettings.defaultConfigurations.myProfileScreen
            .addressLookupServiceProvider === 'LOQATE',
        enableManualEntryForAddressLookup:
          this.$appSettings.defaultConfigurations.myProfileScreen
            .enableManualEntryForAddressLookup
      },
      showExitConfirmation: false,
      showSearchText: true,
      showMe: false
    }
  },
  async created () {
    this.addresses = this.addressList.map((obj) => {
      return { ...obj, formattedAddress: this.formatAddress(obj) }
    })
    this.showMe = true
  },
  methods: {
    formatAddress (address) {
      if (this.settings.isLoqate) return address.addressText

      let a = ''
      if (address?.addressLine1) {
        a = address.addressLine1
      }
      if (address?.city) {
        a = a + `, ${address.city}`
      }
      if (address?.country) {
        a = a + `, ${address.country}`
      }
      if (address?.postCode) {
        a = a + `, ${address.postCode}`
      }
      return a
    },
    async itemClicked (item) {
      const address = await CommonService.addressFindby(item.addressId)
      // TODO: should not appear on production
      if (!address?.stateOrProvince) {
        alert('NO STATE')
        return
      }
      this.$emit('selectAddress', { ...address })
    },
    dispatchError (content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Error',
          content,
          type: 'error',
          width: 400,
          persistent: true,
          close: true,
          component: 'dob-modal'
        }
      })
    }
  },
  computed: {
    filteredAddresses () {
      if (this.filterAddress?.trim().length) {
        return this.addresses.filter((obj) =>
          obj.formattedAddress
            .toLowerCase()
            .includes(this.filterAddress.toLowerCase().trim())
        )
      }
      return this.addresses
    }
  }
}
</script>

<style lang="scss" >
.my-profile-address-lookup-dialog {
  right: 0;
  position: absolute;
}
</style>
